$('html').addClass('js');

var RecaptchaOptions = {
   theme: 'white'
};

/*
 * Domain Master namespace
 *
 */
var DM = {};

/*
 * First things first
 *
 */
DM.init = function() {
	if ( window.parent.document !== document ) {
		$( "body" ).addClass( "iframe" );
	}
	$( ".atk14_no_spam" ).unobfuscate();
	$( "body" )
		.ajaxStart( function() {
			$( this ).addClass( "loading" );
		})
		.ajaxStop( function() {
			$( this ).removeClass( "loading" );
		});
	DM.Forms.init();
	DM.handle_whois_field();
	DM.PopupMenu.init();
	DM.extraContext();
	$("#id_whois_field").autocomplete({
		source: "/cs/suggestions/",
		focus: function(event, ui) {
			event.preventDefault();
			$(this).val(ui.item.label);
		},
	select: function( event, ui ) {
			event.preventDefault();
			$(this).val(ui.item.label);
		window.location.href = ui.item.value;
	}
	});
}

var matched, browser;

jQuery.uaMatch = function( ua ) {
    ua = ua.toLowerCase();

    var match = /(chrome)[ \/]([\w.]+)/.exec( ua ) ||
        /(webkit)[ \/]([\w.]+)/.exec( ua ) ||
        /(opera)(?:.*version|)[ \/]([\w.]+)/.exec( ua ) ||
        /(msie)[\s?]([\w.]+)/.exec( ua ) ||
        /(trident)(?:.*? rv:([\w.]+)|)/.exec( ua ) ||
        ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec( ua ) ||
        [];

    return {
        browser: match[ 1 ] || "",
        version: match[ 2 ] || "0"
    };
};

matched = jQuery.uaMatch( navigator.userAgent );
//IE 11+ fix (Trident)
matched.browser = matched.browser == 'trident' ? 'msie' : matched.browser;
browser = {};

if ( matched.browser ) {
    browser[ matched.browser ] = true;
    browser.version = matched.version;
}

// Chrome is Webkit, but Webkit is also Safari.
if ( browser.chrome ) {
    browser.webkit = true;
} else if ( browser.webkit ) {
    browser.safari = true;
}

jQuery.browser = browser;
// log removed - adds an extra dependency
//log(jQuery.browser)

/*
 * iFrame dialogs
 *
 */
DM.remoteDialog = function( options ) {
	var url, w = $( window ).width() * 0.9,
	defaults = {
		modal: true,
		width: w,
		height: $( window ).height() * 0.9,
		open: function() {
			$( "body" ).css( "overflow", "hidden" );
		},
		close: function( ev ) {
			$( ev.target ).dialog( "destroy" ).remove();
			$( "body" ).css( "overflow", "visible" );
		}
	};

	// we expect "options" to be either object or string
	if ( options.url ) {
		options = $.extend( {}, defaults, options );
		url = options.url;
	} else {
		url = options;
	}

	return $( "<iframe/>", {
		"src": url,
		"class": "remoteDialog",
		load: function() {
			if ( options.width > w ) {
				options.width = w;
			}
			$( this ).width( options.width - 15 );
		}
	}).dialog( options );
};
( function( $ ) {
	$( ".dialog" ).on( "click", function() {
		var title = this.title,
			width = $( "#bodywrap" ).width();
		DM.remoteDialog({
			url: this.href,
			title: title,
			width: width
		});
		return false;
	});
})( jQuery );

/*
 * Popup Menu module
 *
 */
DM.PopupMenu = {

	init: function() {
		this.$links = $('#user_controls').find('a.popup_menu');
		if(this.$links.length == 0) {
			return; // there is no user_controls menu on the page
		}
		this.path = this.$links[0].href.split('#')[0];
		this.attachEvents();
	},

	attachEvents: function() {
		this.$links.click(function() {
			if (DM.PopupMenu.rendered) {
				DM.PopupMenu.handleBehavior(this);
			}
			else {
				DM.PopupMenu.clicked = this;
				DM.PopupMenu.getMenus(DM.PopupMenu.path);
			}
			return false;
		});
	},

	getMenus: function(path) {
		$.getJSON(path + '?format=json', function(data) {
			DM.PopupMenu.insertToDom(data);
		});
	},

	insertToDom: function(data) {
		this.$links.after(function() {
			return data[this.id];
		});
		this.rendered = true;
		this.handleBehavior(this.clicked);
	},

	handleBehavior: function(link) {
		var $link = $(link);
		var $map = $link.next();

		if ($map.is(':visible')) {
			$link.removeClass('active');
			$map.fadeOut();
			$.mask.close();
		}
		else {
			$link.addClass('active');
			DM.PopupMenu.$links.not(link).removeClass('active').next().fadeOut(function() {
				$map.fadeIn().add(DM.PopupMenu.$links).expose({
					opacity: 0,
					onBeforeClose: function() {
						DM.PopupMenu.$links.removeClass('active').next(':visible').fadeOut();
					}
				});
			});
		}
	}
}

/*
 * Dashboard module.
 *
 */
DM.Dashboard = (function() {

	function equal_heights() {
		$('#dashboard > li').each(function(i) {
			i++;
			if (i % 2 == 0) {
				var $box = $(this);
				var $box_prev = $box.prev();
				var box_height = $box.height();
				var box_prev_height = $box_prev.height();

				if (box_height > box_prev_height) {
					$box_prev.height(box_height);
				}
				else {
					$box.height(box_prev_height);
				}
			} else {
				$( this ).addClass( "clear" );
			}
		});
	}

	return {
		init: function() {
			equal_heights();
		}
	};
})();

/*
 * Module for handling keyset registration form
 *
 */
DM.Keyset = (function() {

	return {
		init: function() {
		}
	};
})();

/*
 * Module for handling domains data table.
 *
 */
DM.DomainList = (function() {

	return {
		init: function(trigger_text) {
			DM.DomainList.trigger_text = trigger_text;
			$('#domain_list tbody tr').each(this.handleActions);
			if (window.location.search == '?all=1') {
				$('#id_search').quicksearch('#domain_list tbody tr');
			}
			$(document).bind('click', function() {
				$('#domain_list .actions ul:visible').fadeOut().parent().removeClass('active');
			});
		},

		handleActions: function() {
			var $row = $(this);
			var $actions = $row.find('.actions ul');
			var $trigger = $('<a href="#" title="'+DM.DomainList.trigger_text+'" class="trigger"><span></span></a>').insertBefore($actions),
				p = $trigger.position(),
				w = $trigger.outerWidth(),
				h = $trigger.outerHeight();

			$actions.css({
				'top': p.top + h - 1
			});
			$trigger.click(function() {
				$actions.fadeToggle().parent().toggleClass('active');
				return false;
			});
		}
	};
})();

DM.confirmChange = function() {
	var tpl_trigger = '&nbsp;&nbsp;&nbsp;&nbsp;<a href="#">[+]</a>';
	var $wrapper = $('#confirmation_possibilities');
	var $headings = $wrapper.find('h3').append(tpl_trigger);

	$wrapper.accordion({
		active: false
	});

}

DM.Forms = (function() {

	var tpl_icon_help = '<span class="icon_help">?</span>';

	function handle_required() {
		DM.Forms.$forms.find('.required label span').each(function() {
			$(this).attr('title', $(this).text()).text(' *').show();
		});
	}

	function handle_nameservers_expanding() {
		var $fieldset_ns = $('#nameservers');

		if ($fieldset_ns.length) {
			var $wrappers = $fieldset_ns.children('div');
			var i = 0;

			$wrappers.each(function(j) {
				var $wrapper = $(this);
				var $field = $wrapper.find(':input');
				if ($wrapper.is('.error') || $field.val()) {
					i = j;
				}
			});

			i = i<4 ? 4 : (i%2 ? i+1 : i+2);

			var $wrappers_rest = $wrappers.slice(i).hide();

			var $field_adder = $('<a href="#">További névszerverek megjelenítése</a>').appendTo($fieldset_ns).click(function() {
				$wrappers_rest.not(':visible').slice(0, 2).slideDown();
				if (!$wrappers_rest.not(':visible').length) {
					$(this).hide().remove();
				}
				return false;
			});
		}
	}

	function handle_autofocus() {
		DM.Forms.$forms.filter('.focus').each(function() {
			$(this).find('input[type="text"]:first').focus().select();
		});
	}

	function handle_help() {
		DM.Forms.$forms.find('.help').each(function() {
			var $help = $(this);
			var $field = $help.prev();
			var field_pos_left = $field.position().left;
			var icon_help_pos_left = field_pos_left + $field.outerWidth() + 4;
			var $icon_help = $(tpl_icon_help).insertAfter($field).css('left', icon_help_pos_left);

			$help.css('left', icon_help_pos_left + $icon_help.outerWidth() + 12).append('<div class="tooltip-pointer-left"></div>');

			$icon_help.hoverIntent({
				over: function() {
					if ($field.is('.focused')) {
						$help.fadeTo('fast',0.5).fadeTo('fast',1);
					} else {
						$help.fadeIn();
					}
				},
				out: function() {
					if (!$field.is('.focused')) {
						$help.fadeOut();
					}
				},
				timeout: 1000
			});

			$field.focus(function() {
				$help.fadeIn();
				$field.addClass('focused');
				$icon_help.addClass('hover');
			}).blur(function() {
				$help.fadeOut();
				$field.removeClass('focused');
				$icon_help.removeClass('hover');
			});
		}).addClass('processed');
	}

	function handle_homepage_forms() {
		var $form, $prevForm;
			$('#homepage_forms').tabs({
				show: false,
				activate: function(ev, ui) {
					$form = $(ui.newPanel);
					$prevForm = $(ui.oldPanel);
					$form.find(':text').val($prevForm.find(':text').val());
					$form.find(':text').focus();
				}
			});
	}

	return {
		init: function() {
			DM.Forms.$forms = $('form');
			handle_help();
			handle_required();
			handle_nameservers_expanding();
			handle_autofocus();
			handle_homepage_forms();
		},
		after_ajax: function() {
			DM.Forms.$forms = $('form').not('.processed');
			handle_help();
			handle_required();
		}
	};
})();

DM.handle_whois_field = function(){
	var field = $("#id_whois_field").attr('autocomplete','off');
	var value = field.attr("value") || "";
	if(value.length>0){
		field.focus().select();
	}
	field.click(function(){
		$("#form_search .tooltip").show();
	});
	field.blur(function(){
		$("#form_search .tooltip").hide();
	});
}

DM.domainDetail = (function() {

    function handle_progress() {
        var $teplomer = $('#domain_progress');
        if (!$teplomer.length) return;

        // Hide graph initially if not active
        if (!$teplomer.is('.active')) {
            $teplomer.hide();
        }

        // Attach click handler to the link already in the DOM
        $teplomer.prev('p').find('a').one('click', function() {
            $teplomer.slideToggle('fast');
            return false;
        });
    }

    return {
        init: function() {
            handle_progress();
        }
    };
})();

DM.extraContext = function() {
	var $extra = $('#menu_context li.extra');

	if ($extra.length) {
		var $handle = $extra.find('.btn_more');
		var $menu = $extra.find('ul');

		$handle.click(function() {
			$menu.slideToggle(function() {
				$menu.effect('highlight', {}, 2000);
			});
			$handle.fadeOut();
		});
	}
}

/*
 * Ultratiny plugin for switching between element's title and text
 *
 */
$.fn.ttSwitch = function() {
	return this.each(function() {
		var $this = $(this).find('span'); // TBD
		var text = $this.text(), title = $this.attr('title');
		$this.text(title).attr('title', text);
	});
}

/*
 * Basic dynamic FAQ plugin
 *
 */
$.fn.faqIt = function() {
	return this.each(function() {
		var $this = $(this);

		var $definitions = $this.find('dd').hide();
		var $terms = $this.find('dt').wrapInner('<a href="#"></a>').click(function(ev) {
			if ($(ev.target).is('a')) {
				$(this).next('dd').slideToggle('fast');
				return false;
			}
		});
	});
}

$.fn.further_details = function(text) {
	var msg = text || 'Összes paraméter megjelenítése.';

	return this.each(function() {
		var $wrapper = $(this).addClass('fd_processed');
		var $table = $wrapper.children('table');
		var $further_details = $table.find('.further_details');
		if (!$further_details.length) {
			return;
		}
		var $ref_th = $wrapper.find('th:first');
		$ref_th.css('width', $ref_th.css('width'));

		var orig_display = $further_details.css('display');
		$further_details.hide();

		$('<div style="text-align: right; margin-bottom: 1.5em;"><button class="btn btn_more">' + msg + '<span></span></button></div>').insertAfter($table).bind('click', function() {
			$further_details.css('display', orig_display).find('td').effect('highlight', {}, 2000);
			$wrapper.addClass('fd_clicked');
			$(this).hide();
		});
	});
}

jQuery.fn.fadeToggle = function(speed, easing, callback) {
	return this.animate({opacity: 'toggle'}, speed, easing, callback);
};

$(function(){
	$("a.popup").attr("target", "_blank");
	DM.init();
});

